module.exports = __webpack_public_path__ + "img/APSImg.8bef6e04.png";